import { render } from "./EmployeeShowComponent.vue?vue&type=template&id=37ebf566"
import script from "./EmployeeShowComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/employees/EmployeeShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ebf566"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ebf566', __exports__)) {
    api.reload('37ebf566', __exports__)
  }
  
  module.hot.accept("./EmployeeShowComponent.vue?vue&type=template&id=37ebf566", () => {
    api.rerender('37ebf566', render)
  })

}


export default __exports__